import { jsx as _jsx } from "react/jsx-runtime";
import Add16 from '@carbon/icons-react/es/add/16';
import Save16 from '@carbon/icons-react/es/save/16';
import { Button as RocketlaneButton } from '@rocketlane/ui';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Button as AntdButton } from 'components/atoms/button/button';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
function mapAntdPropsToRadixProps(props) {
    const { type, size, icon, iconPlacement = 'left', loading, style, href, ...restProps } = props;
    const typeToVariantMap = {
        primary: 'primary',
        default: 'secondary',
        dashed: 'secondary',
        link: 'link',
        ghost: 'ghost',
        tertiary: 'secondary',
        success: 'success',
        text: 'ghost'
    };
    const sizeMap = {
        small: 'medium',
        middle: 'medium',
        large: 'large'
    };
    let rightIcon;
    let leftIcon;
    if (icon) {
        if (iconPlacement === 'right') {
            rightIcon = icon;
        } else {
            leftIcon = icon;
        }
    }
    const isLoading = loading ? Boolean(loading) : undefined;
    return {
        ...restProps,
        leftIcon,
        rightIcon,
        href,
        variant: 'danger' in props && props.danger ? 'dangerSecondary' : typeToVariantMap[type || 'default'],
        size: size ? sizeMap[size] : 'medium',
        type: restProps.htmlType || 'button',
        loading: isLoading,
        ...style && {
            style: style
        }
    };
}
const RlButton = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const radixProps = mapAntdPropsToRadixProps(props);
    const { href, ...buttonProps } = radixProps;
    if (href) {
        var _buttonProps_rel;
        return /*#__PURE__*/ _jsx("a", {
            href: href,
            target: buttonProps.target,
            rel: buttonProps.target === '_blank' ? (_buttonProps_rel = buttonProps.rel) !== null && _buttonProps_rel !== void 0 ? _buttonProps_rel : 'noopener noreferrer' : buttonProps.rel,
            children: /*#__PURE__*/ _jsx(RocketlaneButton, {
                ref: ref,
                ...buttonProps
            })
        });
    }
    return /*#__PURE__*/ _jsx(RocketlaneButton, {
        ref: ref,
        ...buttonProps
    });
});
RlButton.displayName = 'RlButton';
const InternalButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const isNewDesignEnabled = useAntdRlUISwitcher();
    if (isNewDesignEnabled) {
        return /*#__PURE__*/ _jsx(RlButton, {
            ref: ref,
            ...props
        });
    }
    return /*#__PURE__*/ _jsx(AntdButton, {
        ref: ref,
        ...props
    });
});
InternalButton.displayName = 'InternalButton';
export const Button = styled(InternalButton)``;
export const SaveButton = (props)=>/*#__PURE__*/ _jsx(Button, {
        icon: /*#__PURE__*/ _jsx(Save16, {}),
        type: "primary",
        iconPlacement: "right",
        ...props
    });
const BaseAddButton = (props)=>/*#__PURE__*/ _jsx(Button, {
        icon: /*#__PURE__*/ _jsx(Add16, {}),
        type: "primary",
        iconPlacement: "right",
        ...props
    });
export const AddButton = withHideIfNotAllowed(BaseAddButton);
export const LinkButton = styled(Button).attrs({
    size: 'small',
    type: 'link'
})`
  font-size: inherit;
  height: auto;
  padding: 0;
`;
export const TertiaryButton = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ _jsx(Button, {
        ref: ref,
        type: "tertiary",
        ...props
    }));
TertiaryButton.displayName = 'TertiaryButton';
Button.displayName = 'Button';
